export default "__VITE_ASSET__c83676f1__"